import { useState, FC, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import moment, { Moment } from "moment";
// @ts-ignore
import { getProjectOwners } from "../../../modules/actions/UserActions";

import {
  Wrapper,
  Head,
  HeadItem,
  Body,
  CustomizeHeader,
  CustomizePopover,
  CustomizeItem,
  CustomizeItems,
  Container,
  AIGenerationLoading,
  CardViewWrapper,
  BulkActionLoading,
  ModelContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ExtraDiv,
  BulkAction,
  CustomizePopoverColumns,
  CustomizePopoverContent,
  CustomizePopoverColumnButton,
  CustomizePopoverResetButton,
  FrozenTextBox,
  UnFrozenWrapper,
  FrozenWrapper,
  CustomizeTitle,
} from "./styled";

import Category, { AddCategory } from "./Category";

// @ts-ignore
import WeightModel from "../WeightModel/WeightModel";

import { IItem, IPlan } from "./@types";

// @ts-ignore
import { changeCategoryOrder } from "modules/actions/PlanActions";

// import expandIcon from './expand.svg';
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
} from "react-beautiful-dnd";
import { ReactComponent as ExpandIcon } from "./expand.svg";
import { ReactComponent as PlusIcon } from "./plus.svg";
import { ReactComponent as Setting } from "assets/svg/setting.svg";
import { ReactComponent as CloseIcon } from "assets/svg/close.svg";
import { ReactComponent as Dragding } from "assets/svg/draging.svg";
import { ReactComponent as SettingGray } from "assets/svg/settingGray.svg";

import { ReactComponent as StarIcon } from "assets/svg/starGray.svg";
import { ReactComponent as PlanProgressIcon } from "assets/svg/planProgress.svg";
import { ReactComponent as DurationIcon } from "assets/svg/duration.svg";
import { ReactComponent as AssigneeIcon } from "assets/svg/assignee.svg";
import { ReactComponent as BellIcon } from "assets/svg/bell.svg";
import { ReactComponent as CalendarIcon } from "assets/svg/calanderGray.svg";
import { ReactComponent as DeleteIcon } from "assets/svg/bin.svg";
import { ReactComponent as UndoIcon } from "assets/svg/undo.svg";
import { ReactComponent as Cross } from "assets/svg/closeBox.svg";
import { ReactComponent as Info } from "assets/svg/info.svg";
import { ReactComponent as ResetIcon } from "assets/svg/reload.svg";

import {
  createPlanCategory,
  updateCustomizeColumn,
  updateCustomizeColumnFrozen,
  updateBulkAction,
  setCustomizeColumnsState,
  // @ts-ignore
} from "modules/actions/PlanActions";
import { DatePicker, Modal, Popover, Select, Switch } from "antd";

// @ts-ignore
import StarsLoading from "../../../assets/svg/yellow-stars.svg";
// @ts-ignore
import LoadingGif from "../../../assets/gifs/assistant-loader.gif";
import { ActionItemsModal } from "../../../components/ActionItemsModal";
import ActionItemCardView from "../../ProjectPlanner/ActionItemCardView";
import {
  actionItemWeightOptions,
  defaultColumns,
} from "../../ProjectPlanner/components/GoalSettings/data";
import { durationList } from "../../../constants";
import { LoadingOutlined } from "@ant-design/icons";
import { errorToast, successToast, undoToast } from "../../../utils/toast";

interface IActionItems {
  planDetails: IPlan;
  isShared: boolean;
  isShort: boolean;
  isExpandAllNotes: boolean;
  isPlanAIGenerated: boolean;
  isAIGeneratedPlanLoading: boolean;
  isListView: boolean;
  filterBy: any;
}

export interface Column {
  key: string;
  title: string;
  isVisible?: boolean;
  isFrozen?: boolean;
}

export interface UnFrozenHeadItemProps {
  column: Column;
  isFrozen?: boolean;
}

const ActionItems: FC<IActionItems> = ({
  planDetails,
  isShared,
  isAIGeneratedPlanLoading,
  isListView,
  filterBy,
}) => {
  const dispatch = useDispatch();
  const mainContainer = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const [popoverHeight, setPopoverHeight] = useState<string>("max-content");
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  const {
    customizeColumn,
    customizeColumnFrozen,
    isUnActiveCategories,
    customizeColumnState,
    // @ts-ignore
  } = useSelector((state) => state.plan.plan);

  // @ts-ignore
  const { users: planUsers } = useSelector((state) => state.user.projectOwners);

  // @ts-ignore
  const { weightModel } = useSelector((state) => state.plan.plan);

  const [activeKey, setActiveKey] = useState<
    { id: string; isExpand: boolean }[]
  >([]);
  const [isAddCategory, setIsAddCategory] = useState(false);
  const [isCustomizePopoverActive, setIsCustomizePopoverActive] =
    useState(false);
  const [isNoteModel, setIsNoteModel] = useState(false);
  const [data, SetData] = useState<any>();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isResetEnabled, setIsResetEnabled] = useState(false);
  const [customizeColumns, setCustomizeColumns] = useState(defaultColumns);

  const [isNewCategoryLoading, setIsNewCategoryLoading] = useState(false);
  const [customizeTab, setCustomizeTab] = useState<"columns" | "freeze">(
    "columns"
  );

  const [isUndo, setIsUndo] = useState(false);
  const [isDeleteModel, setIsDeleteModel] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [deleteItems, setDeleteItems] = useState<any[]>([]);
  const [deleteItemsLoading, setDeleteItemsLoading] = useState(false);

  const isDisabledBulkAction = isDisabled || isUndo;
  const isActionItems =
    planDetails?.categories?.map((category) => category?.action_items).flat()
      ?.length > 0;

  const allActionItems =
    planDetails?.categories?.flatMap(
      (category) => category?.action_items ?? []
    ) ?? [];

  const [isFocus, setIsFocus] = useState<any>({
    weight: false,
    planProgress: false,
    duration: false,
    assignee: false,
    startDate: false,
    dueDate: false,
  });

  const [bulkAction, setBulkAction] = useState<any>({
    weight: "Weight",
    planProgress: "Plan Progress",
    duration: "Duration",
    assignee: "Assignee",
    startDate: null,
    dueDate: null,
    delete: "Delete",
  });

  const [undoData, setUndoData] = useState<{
    action: string;
    value: any;
    oldData: any[];
    showUndo: boolean;
  }>({
    action: "",
    value: null,
    oldData: [],
    showUndo: false,
  });

  const [checkedItems, setCheckedItems] = useState<{
    [key: number]: {
      category: boolean;
      items: { [key: number]: boolean };
    };
  }>({});

  // Auto-scroll functionality for drag and drop
  const handleDragUpdate = (update: any) => {
    const { destination, draggableId, type } = update;

    if (!destination) return;

    const container = document.querySelector(
      ".category-container"
    ) as HTMLElement;
    if (!container) return;

    const { top, bottom } = container.getBoundingClientRect();
    const { clientY } = update;

    const scrollThreshold = 50;
    const scrollSpeed = 20;

    if (clientY - top < scrollThreshold) {
      container.scrollTop -= scrollSpeed;
    } else if (bottom - clientY < scrollThreshold) {
      container.scrollTop += scrollSpeed;
    }
  };

  const handleDragStart = (start: any) => {
    document.body.style.overflow = "hidden";
  };

  const handleDragEnd = (result: DropResult) => {
    document.body.style.overflow = "";
    onDragEndHandle(result);
  };

  const hasSelectedItems = Object.values(checkedItems).some((category) => {
    return Object.values(category.items).some(Boolean);
  });
  const isBulkShow = hasSelectedItems;

  const AssignOptions = (planUsers ?? [])?.map((user: any) => ({
    label: user.email,
    value: user.id,
    initials: user.name
      ? user.name.match(/\b\w/g).join("")
      : user.email[0].toUpperCase(),
  }));

  const selectedAssignee = (planUsers ?? [])?.find(
    (option: any) => option.email === bulkAction?.assignee
  );

  const userName = selectedAssignee
    ? selectedAssignee?.first_name && selectedAssignee?.last_name
      ? selectedAssignee?.first_name.substring(0, 1) +
        selectedAssignee?.last_name.substring(0, 1)
      : selectedAssignee?.name
      ? selectedAssignee?.name.split(" ").length > 1
        ? selectedAssignee.name.split(" ")[0].substring(0, 1) +
          selectedAssignee.name.split(" ")[1].substring(0, 1)
        : selectedAssignee.name.substring(0, 2)
      : selectedAssignee?.email?.substring(0, 2)
    : "Assignee";

  useEffect(() => {
    const updatedActiveKey = planDetails.categories.map((category) => {
      const existingKey = activeKey.find(
        (keyItem) => keyItem.id === category.id.toString()
      );
      return existingKey || { id: category.id.toString(), isExpand: true };
    });

    // Ensure we're not losing any existing keys that might not be in the current planDetails.categories
    const existingIds = planDetails.categories.map((category) =>
      category.id.toString()
    );
    const preservedKeys = activeKey.filter((keyItem) =>
      existingIds.includes(keyItem.id)
    );

    setActiveKey([...new Set([...updatedActiveKey, ...preservedKeys])]);
  }, [planDetails]);

  const handleToggle = (id: string) => {
    setActiveKey(
      activeKey.map((keyItem) =>
        keyItem.id === id
          ? { ...keyItem, isExpand: !keyItem.isExpand }
          : keyItem
      )
    );
  };

  const handleAddCategory = () => {
    setIsAddCategory(!isAddCategory);
  };

  const handleCategoryCreate = (value: string) => {
    if (!value) {
      setIsAddCategory(false);
      return;
    }

    setIsNewCategoryLoading(true);

    const payload = {
      name: value,
      start_line: moment(planDetails?.start_line ?? new Date()).format(
        "YYYY-MM-DD"
      ),
      dead_line: moment(planDetails?.dead_line ?? new Date()).format(
        "YYYY-MM-DD"
      ),
      project_plan: planDetails?.id,
    };

    dispatch(createPlanCategory(payload, handleCategoryCreateCallback));
  };

  const handleCategoryCreateCallback = () => {
    setIsAddCategory(false);
    setIsNewCategoryLoading(false);
  };

  const handleCollapseExpandAll = () => {
    if (
      activeKey.filter((keyItem) => keyItem.isExpand).length ===
      planDetails.categories.length
    ) {
      setActiveKey((prev) =>
        prev.map((keyItem) => ({ ...keyItem, isExpand: false }))
      );
    } else {
      setActiveKey((prev) =>
        prev.map((keyItem) => ({ ...keyItem, isExpand: true }))
      );
    }
  };

  const handleAdjustWeightToggle = () => {
    setCheckedItems({});
    dispatch({
      type: "WEIGHT_MODEL",
      payload: !weightModel,
    });
  };

  const onDragEndHandle = (result: DropResult) => {
    const { source, destination } = result;

    if (!destination) return;

    const sourceCategoryId: any = source.droppableId;
    const destinationCategoryId: any = destination.droppableId;

    const sourceCategory = planDetails.categories.find(
      (cat) => cat.id.toString() === sourceCategoryId
    );
    const movedItem = sourceCategory?.action_items[source.index];

    if (sourceCategoryId === destinationCategoryId) {
      handleReorderWithinCategory(
        sourceCategoryId,
        source.index,
        destination.index
      );

      if (movedItem && checkedItems[sourceCategoryId]?.items?.[movedItem.id]) {
        setCheckedItems((prev) => ({
          ...prev,
          [sourceCategoryId]: {
            ...prev[sourceCategoryId],
            items: {
              ...prev[sourceCategoryId]?.items,
              [movedItem.id]: true,
            },
          },
        }));
      }
    } else {
      handleMoveBetweenCategories(
        sourceCategoryId,
        destinationCategoryId,
        source.index,
        destination.index
      );

      if (movedItem && checkedItems[sourceCategoryId]?.items?.[movedItem.id]) {
        setCheckedItems((prev) => {
          const sourceItems = { ...prev[sourceCategoryId]?.items };
          delete sourceItems[movedItem.id];

          return {
            ...prev,
            [sourceCategoryId]: {
              ...prev[sourceCategoryId],
              items: sourceItems,
            },
            [destinationCategoryId]: {
              ...prev[destinationCategoryId],
              items: {
                ...prev[destinationCategoryId]?.items,
                [movedItem.id]: true,
              },
            },
          };
        });
      }
    }
  };

  // Reordering within the same category
  const handleReorderWithinCategory = (
    categoryId: any,
    sourceIndex: any,
    destinationIndex: any
  ) => {
    const updatedCategories = [...planDetails.categories];
    const category = updatedCategories.find(
      (cat) => cat.id.toString() === categoryId
    );

    if (!category) return;

    const reorderedItems = Array.from(category.action_items);
    const [movedItem] = reorderedItems.splice(sourceIndex, 1);
    reorderedItems.splice(destinationIndex, 0, movedItem);

    // Update the category with the new order of action items
    category.action_items = reorderedItems;

    // Send updated actions to the API
    sendActionsToAPI(updatedCategories);
  };

  // Moving between different categories
  const handleMoveBetweenCategories = (
    sourceCategoryId: any,
    destinationCategoryId: any,
    sourceIndex: any,
    destinationIndex: any
  ) => {
    const updatedCategories = [...planDetails.categories];

    const sourceCategory = updatedCategories.find(
      (cat) => cat.id.toString() === sourceCategoryId
    );
    const destinationCategory = updatedCategories.find(
      (cat) => cat.id.toString() === destinationCategoryId
    );

    if (!sourceCategory || !destinationCategory) return;

    const sourceItems = Array.from(sourceCategory.action_items);
    const [movedItem] = sourceItems.splice(sourceIndex, 1);

    const destinationItems = Array.from(destinationCategory.action_items);
    destinationItems.splice(destinationIndex, 0, movedItem);

    // Update the action items for source and destination categories
    sourceCategory.action_items = sourceItems;
    destinationCategory.action_items = destinationItems;

    // Send updated actions to the API
    sendActionsToAPI(updatedCategories);
  };

  const handleResetToDefault = async () => {
    setCustomizeColumns(defaultColumns);

    await dispatch(
      updateCustomizeColumn({
        project_plan: planDetails.id,
        column: defaultColumns.map((item) => item.key),
      })
    );

    await dispatch(
      updateCustomizeColumnFrozen({
        project_plan: planDetails.id,
        freeze_column: [],
      })
    );

    await dispatch(setCustomizeColumnsState(defaultColumns));

    setIsCustomizePopoverActive(false);
  };

  const sendActionsToAPI = (updatedCategories: any) => {
    // Construct the payload based on the updated categories
    const actions: any = [];

    updatedCategories.forEach((category: any) => {
      category.action_items.forEach((item: any, index: number) => {
        actions.push({
          id: item.id,
          order_id: index,
          category: category.id,
        });
      });
    });

    const payload = { actions };

    dispatch(changeCategoryOrder(payload, planDetails?.id));
  };

  const onDragEnd = (result: any) => {
    const { source, destination } = result;

    if (!destination) return;

    const sourceIsFrozen = source.droppableId === "frozen";
    const destinationIsFrozen = destination.droppableId === "frozen";

    if (sourceIsFrozen !== destinationIsFrozen) {
      return;
    }

    const frozenItems = customizeColumns.filter((col) => col.isFrozen);
    const unfrozenItems = customizeColumns.filter((col) => !col.isFrozen);

    if (sourceIsFrozen) {
      const [movedItem] = frozenItems.splice(source.index, 1);
      frozenItems.splice(destination.index, 0, movedItem);

      const updatedColumns = [...frozenItems, ...unfrozenItems];
      setCustomizeColumns(updatedColumns);

      if (!isShared) {
        const payload = {
          project_plan: planDetails.id,
          column: updatedColumns
            .filter((item) => item.isVisible)
            .map((item) => item.key),
        };
        dispatch(updateCustomizeColumn(payload));
        dispatch(setCustomizeColumnsState(updatedColumns));
      }
    } else {
      const [movedItem] = unfrozenItems.splice(source.index, 1);
      unfrozenItems.splice(destination.index, 0, movedItem);

      const updatedColumns = [...frozenItems, ...unfrozenItems];
      setCustomizeColumns(updatedColumns);

      if (!isShared) {
        const payload = {
          project_plan: planDetails.id,
          column: updatedColumns
            .filter((item) => item.isVisible)
            .map((item) => item.key),
        };
        dispatch(updateCustomizeColumn(payload));
        dispatch(setCustomizeColumnsState(updatedColumns));
      }
    }
  };

  // First, add a function to handle drag in the freeze tab
  const onDragEndFreeze = (result: any) => {
    const { source, destination } = result;

    if (!destination) return;

    const sourceIsFrozen = source.droppableId === "frozen-section";
    const destinationIsFrozen = destination.droppableId === "frozen-section";

    // Get the working lists
    const frozenItems = customizeColumns.filter((col) => col.isFrozen);
    const unfrozenItems = customizeColumns.filter((col) => !col.isFrozen);

    if (sourceIsFrozen === destinationIsFrozen) {
      // Reordering within the same section
      const workingList = sourceIsFrozen ? frozenItems : unfrozenItems;
      const reorderedItems = Array.from(workingList);
      const [movedItem] = reorderedItems.splice(source.index, 1);
      reorderedItems.splice(destination.index, 0, movedItem);

      // Update the full list while preserving frozen state
      const updatedColumns = sourceIsFrozen
        ? [...reorderedItems, ...unfrozenItems]
        : [...frozenItems, ...reorderedItems];

      const payload = {
        project_plan: planDetails.id,
        column: updatedColumns
          .filter((item) => item.isVisible)
          .map((item) => item.key),
      };

      dispatch(updateCustomizeColumn(payload));
      dispatch(setCustomizeColumnsState(updatedColumns));
      setCustomizeColumns(updatedColumns);
    }
  };

  const checkColumns = (defaultColumns: any, sortedColumns: any) => {
    let isOrderCorrect = true;
    let isVisibilityCorrect = true;
    let isFrozenCorrect = true;

    for (let i = 0; i < defaultColumns.length; i++) {
      if (defaultColumns[i].id !== sortedColumns[i].id) {
        isOrderCorrect = false;
        break;
      }
    }

    sortedColumns?.forEach((column: any) => {
      if (column.isVisible === false) {
        isVisibilityCorrect = false;
      }
    });

    sortedColumns?.forEach((column: any) => {
      if (column.isFrozen === true) {
        isFrozenCorrect = false;
      }
    });

    return {
      isOrderCorrect,
      isVisibilityCorrect,
      isFrozenCorrect,
    };
  };

  useEffect(() => {
    let undoTimer: NodeJS.Timeout;
    if (isUndo) {
      undoTimer = setTimeout(() => {
        const newCheckedItems = { ...checkedItems };
        deleteItems.forEach((item) => {
          const categoryId = item.category;
          if (newCheckedItems[categoryId]?.items) {
            delete newCheckedItems[categoryId].items[item.id];
          }
        });

        const isActionItemsLength =
          planDetails?.categories
            ?.map((category) => category?.action_items)
            ?.flat()?.length === deleteItems?.length;

        if (isActionItemsLength) {
          setCheckedItems({});
        } else {
          setCheckedItems(newCheckedItems);
        }

        setIsUndo(false);
        setUndoData({
          action: "",
          value: null,
          oldData: [],
          showUndo: false,
        });
        setDeleteItems([]);
        setIsDeleteModel(false);
        setIsFocus({
          name: false,
          weight: false,
          planProgress: false,
          duration: false,
          assignee: false,
          dueDate: false,
          startDate: false,
        });
      }, 10000);
    }
    return () => clearTimeout(undoTimer);
  }, [isUndo]);

  const isDateDisabled = (
    current: Moment,
    name: "start_line" | "dead_line"
  ): boolean => {
    if (!current) return false;

    if (name === "start_line") {
      if (
        planDetails?.start_line &&
        current.isBefore(moment(planDetails.start_line), "day")
      ) {
        return true;
      }
      if (
        planDetails?.dead_line &&
        current.isAfter(moment(planDetails.dead_line), "day")
      ) {
        return true;
      }
    } else if (name === "dead_line") {
      if (
        planDetails?.start_line &&
        current.isBefore(moment(planDetails.start_line), "day")
      ) {
        return true;
      }
      if (
        planDetails?.dead_line &&
        current.isAfter(moment(planDetails.dead_line), "day")
      ) {
        return true;
      }
    }

    return false;
  };

  const handleBulkAction = async (action: string, value: any) => {
    setIsDisabled(true);

    // Get all selected items data
    const selectedItemsData = planDetails.categories.reduce(
      (acc: IItem[], category) => {
        const categoryCheckedItems = checkedItems[category.id]?.items || {};
        const selectedItems = category.action_items.filter(
          (item) => categoryCheckedItems[item.id]
        );
        return [...acc, ...selectedItems];
      },
      []
    );

    // Store the original data for undo
    const originalData = selectedItemsData.map((item) => ({
      id: item.id,
      name: item.name,
      category: item.category,
      weight: item.weight,
      plan_progress: item.plan_progress,
      duration: item.duration,
      start_line: item.start_line,
      dead_line: item.dead_line,
      status: item.status,
      responsible_person:
        item?.responsible_person?.id || item?.responsible_person || null,
    }));

    const updatedData = selectedItemsData.map((item) => ({
      id: item.id,
      name: item.name,
      category: item.category,
      weight: item.weight,
      plan_progress: item.plan_progress,
      duration: item.duration,
      start_line: item.start_line,
      dead_line: item.dead_line,
      responsible_person: item?.responsible_person?.id || null,
    }));

    const payload = {
      action_items: updatedData?.map((item) => ({
        ...item,
        ...(action === "weight" && {
          weight: value ?? item.weight,
        }),
        ...(action === "planProgress" && {
          plan_progress: value ?? item.plan_progress,
        }),
        ...(action === "duration" && {
          duration: value ?? item.duration,
        }),
        ...(action === "assignee" && {
          responsible_person: value?.value ?? item.responsible_person,
        }),
        ...(action === "startDate" && {
          start_line: moment(value).format("YYYY-MM-DD") || item.start_line,
        }),
        ...(action === "dueDate" && {
          dead_line: moment(value).format("YYYY-MM-DD") || item.dead_line,
        }),
      })),
    };

    try {
      await dispatch(
        updateBulkAction(payload, planDetails?.id, handleBulkActionCallback)
      );
      // Set undo data with original values
      setUndoData({
        action,
        value,
        oldData: originalData,
        showUndo: true,
      });
    } catch (error) {
      console.error("Error updating bulk actions:", error);
    }
  };

  const handleBulkActionCallback = () => {
    successToast("Selected items updated successfully.");
    setIsDisabled(false);
    setIsUndo(true);
    setBulkAction({
      weight: "Weight",
      planProgress: "Plan Progress",
      duration: "Duration",
      assignee: "Assignee",
      startDate: null,
      dueDate: null,
      delete: "Delete",
    });
    setIsFocus({
      name: false,
      weight: false,
      planProgress: false,
      duration: false,
      assignee: false,
      dueDate: false,
      startDate: false,
    });
  };

  const handleUndoCallback = () => {
    undoToast("Your previous changes have been reverted.", "Undo Successful");
    setIsDisabled(false);
    setCheckedItems({});
    setIsUndo(false);
    setUndoData({
      action: "",
      value: null,
      oldData: [],
      showUndo: false,
    });
  };

  const handleError = () => {
    setIsDisabled(false);
    setCheckedItems({});
    errorToast("Error undoing action");
    setIsUndo(false);
    setUndoData({
      action: "",
      value: null,
      oldData: [],
      showUndo: false,
    });
  };

  const handleUndo = async () => {
    if (!undoData.oldData.length || isDisabled) return;

    setIsDisabled(true);

    const undoDataPayload = {
      action_items: undoData.oldData.map((item) => ({
        ...item,
        ...(undoData.action === "weight" && {
          weight: item.weight,
        }),
        ...(undoData.action === "planProgress" && {
          plan_progress: item.plan_progress,
          status: item.status,
        }),
        ...(undoData.action === "duration" && {
          duration: item.duration,
        }),
        ...(undoData.action === "assignee" && {
          responsible_person:
            item?.responsible_person?.id || item?.responsible_person,
        }),
        ...(undoData.action === "startDate" && {
          start_line: moment(item?.start_line).format("YYYY-MM-DD"),
        }),
        ...(undoData.action === "dueDate" && {
          dead_line: moment(item?.dead_line).format("YYYY-MM-DD"),
        }),
      })),
    };

    const updatedData = {
      action_items: undoData.oldData.map((item) => ({
        name: item.name,
        category: item.category,
        weight: item.weight,
        plan_progress: item.plan_progress,
        duration: item.duration,
        start_line: item.start_line,
        dead_line: item.dead_line,
        responsible_person:
          item?.responsible_person?.id || item?.responsible_person,
      })),
    };

    const payload =
      undoData?.action === "delete" ? updatedData : undoDataPayload;

    try {
      await dispatch(
        updateBulkAction(
          payload,
          planDetails?.id,
          handleUndoCallback,
          handleError
        )
      );
    } catch (error) {
      console.error("Error undoing action:", error);
    }
  };

  const handleDeleteItems = () => {
    if (isDisabledBulkAction) return;

    const selectedItemsData = planDetails.categories.reduce(
      (acc: any[], category) => {
        const categoryCheckedItems = checkedItems[category.id]?.items || {};
        const selectedItems = category.action_items.filter(
          (item) => categoryCheckedItems[item.id]
        );
        return [...acc, ...selectedItems];
      },
      []
    );

    setDeleteItems(selectedItemsData);
    setIsDeleteModel(true);
  };

  const handleDeleteBulkItems = async () => {
    setDeleteItemsLoading(true);

    const payload = {
      deletedActionItemsIds: deleteItems?.map((item) => item.id),
    };

    try {
      await dispatch(
        updateBulkAction(
          payload,
          planDetails?.id,
          handleDeleteBulkItemsCallback
        )
      );
    } catch (error) {
      console.error("Error deleting bulk items:", error);
    }
  };

  const handleDeleteBulkItemsCallback = () => {
    setIsUndo(true);
    setDeleteItemsLoading(false);
    setIsDeleteModel(false);
    setUndoData({
      action: "delete",
      value: null,
      oldData: deleteItems,
      showUndo: true,
    });

    successToast("Deleted successfully");
  };

  const deletedModelClose = () => {
    setIsDeleteModel(false);
    setDeleteItems([]);
  };

  useEffect(() => {
    if (isUndo) {
      setIsUndo(false);
      setDeleteItems([]);
      setIsDeleteModel(false);
      setUndoData({
        action: "",
        value: null,
        oldData: [],
        showUndo: false,
      });
    }
  }, [checkedItems]);

  useEffect(() => {
    if (!isShared) {
      dispatch(getProjectOwners(""));
    }
  }, [customizeColumns]);

  const combineActionItems = planDetails?.categories
    .map((category) => category?.action_items)
    ?.flat();

  const initialStatus = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
  };

  const groupedByStatus = combineActionItems?.reduce(
    (acc: any, project: any) => {
      const { status } = project;
      if (!acc[status]) {
        acc[status] = [];
      }
      acc[status].push(project);
      return acc;
    },
    { ...initialStatus }
  );

  const handleChangeColumnVisibility = (key: string, value: boolean) => {
    const UpdatedColumns = customizeColumns?.map((item) =>
      item.key === key
        ? {
            ...item,
            isVisible: value,
          }
        : item
    );

    const payload = {
      project_plan: planDetails.id,
      column: UpdatedColumns?.filter((item) => item.isVisible).map(
        (item) => item.key
      ),
    };

    dispatch(updateCustomizeColumn(payload));
    dispatch(setCustomizeColumnsState(UpdatedColumns));
    setCustomizeColumns(UpdatedColumns);
  };

  const handleColumnFrozenChange = (key: string, value: boolean) => {
    const updatedColumns = customizeColumns.map((item) =>
      item.key === key
        ? {
            ...item,
            isFrozen: value,
          }
        : item
    );

    setCustomizeColumns(updatedColumns);

    if (!isShared) {
      const payload = {
        project_plan: planDetails.id,
        freeze_column: updatedColumns
          .filter((item) => item.isFrozen)
          .map((item) => item.key),
      };
      dispatch(updateCustomizeColumnFrozen(payload));
      dispatch(setCustomizeColumnsState(updatedColumns));
    }
  };

  useEffect(() => {
    if (customizeColumn) {
      const visibleColumns =
        customizeColumn?.[0]?.column?.length > 0
          ? customizeColumn?.[0]?.column
          : [];

      const frozenColumns =
        customizeColumnFrozen?.length > 0
          ? customizeColumnFrozen?.[0]?.freeze_column?.length > 0
            ? customizeColumnFrozen?.[0]?.freeze_column
            : []
          : [];

      const formattedColumns = defaultColumns.map((column) => ({
        ...column,
        isVisible: visibleColumns?.includes(column.key),
        isFrozen: frozenColumns?.includes(column.key),
      }));

      const sortedColumns = [...formattedColumns].sort((a, b) => {
        const indexA = visibleColumns?.indexOf(a.key);
        const indexB = visibleColumns?.indexOf(b.key);
        return (
          (indexA === -1 ? Number.MAX_VALUE : indexA) -
          (indexB === -1 ? Number.MAX_VALUE : indexB)
        );
      });

      setCustomizeColumns(sortedColumns);
    }
  }, [customizeColumn, customizeColumnFrozen]);

  useEffect(() => {
    if (customizeColumnState) {
      setCustomizeColumns(customizeColumnState);
    }
  }, [customizeColumnState]);

  useEffect(() => {
    if (customizeColumns) {
      const isDisabled = checkColumns(defaultColumns, customizeColumns);

      setIsResetEnabled(
        isDisabled.isOrderCorrect &&
          isDisabled.isVisibilityCorrect &&
          isDisabled.isFrozenCorrect
      );
    }
  }, [customizeColumns]);

  useEffect(() => {
    const updatePopoverHeight = () => {
      if (popoverRef.current) {
        requestAnimationFrame(() => {
          if (popoverRef.current) {
            const popoverTop = popoverRef.current.getBoundingClientRect().top;
            const availableHeight = window.innerHeight - popoverTop - 20;
            const maxHeight = 500;
            const newHeight = Math.max(
              200,
              Math.min(availableHeight, maxHeight)
            );
            setPopoverHeight(`${newHeight}px`);
          }
        });
      }
    };

    if (isCustomizePopoverActive) {
      updatePopoverHeight();

      const fallbackTimer = setTimeout(updatePopoverHeight, 100);

      window.addEventListener("resize", updatePopoverHeight);

      return () => {
        window.removeEventListener("resize", updatePopoverHeight);
        clearTimeout(fallbackTimer);
      };
    }
  }, [isCustomizePopoverActive]);

  const updatePopoverPosition = useCallback(() => {
    if (triggerRef.current && isCustomizePopoverActive) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPopoverPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.right + window.scrollX - 13,
      });
    }
  }, [isCustomizePopoverActive]);

  useEffect(() => {
    if (isCustomizePopoverActive) {
      updatePopoverPosition();

      window.addEventListener("scroll", updatePopoverPosition, true);

      const container = mainContainer.current;
      if (container) {
        container.addEventListener("scroll", updatePopoverPosition, true);
      }

      window.addEventListener("resize", updatePopoverPosition);
    }

    return () => {
      window.removeEventListener("scroll", updatePopoverPosition, true);
      window.removeEventListener("resize", updatePopoverPosition);

      const container = mainContainer.current;
      if (container) {
        container.removeEventListener("scroll", updatePopoverPosition, true);
      }
    };
  }, [isCustomizePopoverActive, updatePopoverPosition]);
  
  if (isAIGeneratedPlanLoading) {
    return (
      <AIGenerationLoading>
        <img src={StarsLoading} alt="Generating" />
        <p>Suggesting Project Plan...</p>
        <img src={LoadingGif} alt="Generating" />
      </AIGenerationLoading>
    );
  }

  const FrozenHeadItem: FC = () => (
    <>
      <HeadItem $type="small" $isCheckbox>
        <input
          type="checkbox"
          disabled={isShared || !isActionItems}
          style={{
            opacity: isShared || !isActionItems ? 0.5 : 1,
            cursor: isShared || !isActionItems ? "not-allowed" : "pointer",
          }}
          checked={
            planDetails.categories?.length > 0 &&
            planDetails.categories
              .filter((category) => {
                const isMarkedInactive = isUnActiveCategories.find(
                  (item: { id: number; isUnActive: boolean }) =>
                    item.id === category.id && !item.isUnActive
                );
                const isCategoryItems = category.action_items?.length > 0;
                return (
                  !isMarkedInactive && category.is_active && isCategoryItems
                );
              })
              .every(
                (category) =>
                  checkedItems?.[category.id]?.category === true &&
                  category.action_items?.every(
                    (item) =>
                      checkedItems?.[category.id]?.items?.[item.id] === true
                  )
              )
          }
          onChange={(e) => {
            if (isShared || !isActionItems) return;
            const isChecked = e.target.checked;
            const newCheckedItems = planDetails.categories.reduce(
              (acc: any, category) => {
                const isMarkedInactive = isUnActiveCategories.find(
                  (item: { id: number; isUnActive: boolean }) =>
                    item.id === category.id && !item.isUnActive
                );

                if (isMarkedInactive || !category.is_active) {
                  acc[category.id] = checkedItems?.[category.id] || {
                    category: false,
                    items: Object.fromEntries(
                      (category.action_items ?? []).map((item) => [
                        item.id,
                        false,
                      ])
                    ),
                  };
                  return acc;
                }

                acc[category.id] = {
                  category: isChecked,
                  items: Object.fromEntries(
                    (category.action_items ?? []).map((item) => [
                      item.id,
                      isChecked,
                    ])
                  ),
                };
                return acc;
              },
              {}
            );
            setCheckedItems(newCheckedItems);
          }}
          ref={(input) => {
            if (input) {
              if (!isActionItems) return;
              const activeCategories = planDetails.categories.filter(
                (category) => {
                  const isMarkedInactive = isUnActiveCategories.find(
                    (item: { id: number; isUnActive: boolean }) =>
                      item.id === category.id && !item.isUnActive
                  );
                  return !isMarkedInactive && category.is_active;
                }
              );

              const someChecked = activeCategories.some(
                (category) =>
                  checkedItems?.[category.id]?.category === true ||
                  category.action_items?.some(
                    (item) =>
                      checkedItems?.[category.id]?.items?.[item.id] === true
                  )
              );

              const allChecked =
                activeCategories.length > 0 &&
                activeCategories.every(
                  (category) =>
                    checkedItems?.[category.id]?.category === true &&
                    category.action_items?.every(
                      (item) =>
                        checkedItems?.[category.id]?.items?.[item.id] === true
                    )
                );

              input.indeterminate = someChecked && !allChecked;
            }
          }}
        />
      </HeadItem>

      <HeadItem $type="small">
        <ExpandIcon
          className="cursor-pointer"
          onClick={handleCollapseExpandAll}
        />
      </HeadItem>

      <HeadItem $type="large">
        Category & Action Items
        {!isShared && (
          <span
            onClick={handleAddCategory}
            className="add-category"
            style={{
              opacity: isAddCategory ? 0.5 : 1,
              pointerEvents: isAddCategory ? "none" : "auto",
              cursor: isAddCategory ? "not-allowed" : "pointer",
            }}
          >
            <PlusIcon />
            Add Category
          </span>
        )}
      </HeadItem>
    </>
  );

  const UnFrozenHeadItem: FC<UnFrozenHeadItemProps> = ({
    column,
    isFrozen,
  }) => {
    if (!column || column.key === "action_items" || !column?.isVisible)
      return null;

    const shouldRender =
      (!isFrozen && !column.isFrozen) || (isFrozen && column.isFrozen);

    if (!shouldRender) return null;

    return (
      <HeadItem $type="medium" key={column.key}>
        {column.title}
      </HeadItem>
    );
  };

  return (
    <>
      <Modal
        footer={null}
        closable={false}
        onCancel={deletedModelClose}
        title={false}
        open={isDeleteModel}
        centered
        width={460}
        className="metricModel"
      >
        <ModalHeader>
          <div className="modal-left">
            <div className="modal-left-info">
              <Info />
            </div>
            <h3>Delete Action Items</h3>
          </div>
          <Cross className={"c-pointer"} onClick={deletedModelClose} />
        </ModalHeader>

        <ModelContent>
          Are you sure you want to delete following action items? <br />
          This action can be reversed by clicking on undo button.{" "}
        </ModelContent>

        <ModalBody>
          {deleteItems?.map((item) => (
            <li key={item.id}>{item.name}</li>
          ))}
        </ModalBody>

        <ModalFooter>
          <button onClick={deletedModelClose} disabled={deleteItemsLoading}>
            Cancel
          </button>
          <button onClick={handleDeleteBulkItems} disabled={deleteItemsLoading}>
            {deleteItemsLoading ? <LoadingOutlined /> : "Delete"}
          </button>
        </ModalFooter>
      </Modal>

      <WeightModel />

      {isNoteModel && data && (
        <ActionItemsModal
          isActionItem
          allData={data}
          data={data?.notes?.[0]}
          actionItemsModal={isNoteModel}
          setActionItemsModal={setIsNoteModel}
          projectPlanId={data.project_plan_id}
          PlanDetails={planDetails}
          isButtonDisabled={isButtonDisabled}
          setIsButtonDisabled={setIsButtonDisabled}
          isTask={true}
        />
      )}

      {isListView ? (
        <Container ref={mainContainer} className="category-container">
          <Wrapper>
            <Head>
              {(customizeColumns || []).some((col) => col.isFrozen) && (
                <FrozenWrapper>
                  <FrozenHeadItem />

                  {(customizeColumns || [])
                    .filter((column) => column.isFrozen)
                    .map((column) => (
                      <UnFrozenHeadItem
                        column={column}
                        key={column.key}
                        isFrozen={true}
                      />
                    ))}
                </FrozenWrapper>
              )}

              <UnFrozenWrapper>
                {!(customizeColumns || []).some((col) => col.isFrozen) && (
                  <FrozenHeadItem />
                )}

                {(customizeColumns || [])
                  .filter((column) => !column.isFrozen)
                  .map((column) => (
                    <UnFrozenHeadItem column={column} key={column.key} />
                  ))}

                <HeadItem $type="medium">State</HeadItem>

                <HeadItem $stickyRight $type="small">
                  <div className="cursor-pointer" ref={triggerRef}>
                    <Popover
                      content={
                        <>
                          <CustomizePopover
                            ref={popoverRef}
                            style={{ height: popoverHeight }}
                          >
                            <CustomizeHeader>
                              <h6>Customize Table</h6>
                              <CloseIcon
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setIsCustomizePopoverActive(false)
                                }
                              />
                            </CustomizeHeader>

                            <CustomizePopoverColumns>
                              <CustomizePopoverColumnButton
                                active={customizeTab === "columns"}
                                onClick={() => setCustomizeTab("columns")}
                              >
                                Columns
                              </CustomizePopoverColumnButton>
                              <CustomizePopoverColumnButton
                                active={customizeTab === "freeze"}
                                onClick={() => setCustomizeTab("freeze")}
                              >
                                Freeze Columns
                              </CustomizePopoverColumnButton>
                              <CustomizePopoverResetButton
                                style={{
                                  opacity: isResetEnabled ? 0.4 : 1,
                                  cursor: isResetEnabled
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                onClick={handleResetToDefault}
                                disabled={isResetEnabled}
                                title="Reset"
                              >
                                <ResetIcon />
                                Reset
                              </CustomizePopoverResetButton>
                            </CustomizePopoverColumns>

                            <CustomizePopoverContent>
                              {customizeTab === "columns" && (
                                <DragDropContext onDragEnd={onDragEnd}>
                                  <div>
                                    {customizeColumns.filter(
                                      (column) =>
                                        column.isFrozen &&
                                        column.key !== "action_items"
                                    )?.length > 0 && (
                                      <div>
                                        <CustomizeTitle>
                                          Frozen Columns
                                        </CustomizeTitle>
                                        <Droppable
                                          droppableId="frozen"
                                          isDropDisabled={false}
                                        >
                                          {(provided, snapshot) => (
                                            <CustomizeItems
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                              isDraggingOver={
                                                snapshot.isDraggingOver
                                              }
                                              isFrozen
                                            >
                                              {customizeColumns
                                                .filter(
                                                  (column) =>
                                                    column.isFrozen &&
                                                    column.key !==
                                                      "action_items"
                                                )
                                                .map((column, index) => {
                                                  const isActionItem =
                                                    column.key ===
                                                    "action_items";
                                                  return (
                                                    <Draggable
                                                      key={column.key}
                                                      draggableId={column.key}
                                                      index={index}
                                                    >
                                                      {(provided, snapshot) => (
                                                        <CustomizeItem
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                        >
                                                          <div className="customizeItem-title">
                                                            <div
                                                              {...provided.dragHandleProps}
                                                              style={{
                                                                cursor:
                                                                  isActionItem
                                                                    ? "default"
                                                                    : "grab",
                                                                display:
                                                                  "inline-block",
                                                                opacity:
                                                                  isActionItem
                                                                    ? 0
                                                                    : 1,
                                                                overflow:
                                                                  isActionItem
                                                                    ? "hidden"
                                                                    : "visible",
                                                              }}
                                                            >
                                                              <Dragding />
                                                            </div>
                                                            <h4>
                                                              {column.title}
                                                            </h4>
                                                          </div>
                                                          <Switch
                                                            checked={
                                                              column.isVisible
                                                            }
                                                            size="small"
                                                            onChange={(
                                                              value
                                                            ) => {
                                                              handleChangeColumnVisibility(
                                                                column.key,
                                                                value
                                                              );
                                                            }}
                                                          />
                                                        </CustomizeItem>
                                                      )}
                                                    </Draggable>
                                                  );
                                                })}
                                              {provided.placeholder}
                                            </CustomizeItems>
                                          )}
                                        </Droppable>
                                      </div>
                                    )}

                                    {customizeColumns.filter(
                                      (column) =>
                                        !column.isFrozen &&
                                        column.key !== "action_items"
                                    )?.length > 0 && (
                                      <div>
                                        <CustomizeTitle>
                                          Unfrozen Columns
                                        </CustomizeTitle>
                                        <Droppable
                                          droppableId="unfrozen"
                                          isDropDisabled={false}
                                        >
                                          {(provided, snapshot) => (
                                            <CustomizeItems
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                              isDraggingOver={
                                                snapshot.isDraggingOver
                                              }
                                              isFrozen={false}
                                            >
                                              {customizeColumns
                                                .filter(
                                                  (column) =>
                                                    !column.isFrozen &&
                                                    column.key !==
                                                      "action_items"
                                                )
                                                .map((column, index) => (
                                                  <Draggable
                                                    key={column.key}
                                                    draggableId={column.key}
                                                    index={index}
                                                  >
                                                    {(provided, snapshot) => (
                                                      <CustomizeItem
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                      >
                                                        <div className="customizeItem-title">
                                                          <div
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                              cursor: "grab",
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <Dragding />
                                                          </div>
                                                          <h4>
                                                            {column.title}
                                                          </h4>
                                                        </div>
                                                        <Switch
                                                          checked={
                                                            column.isVisible
                                                          }
                                                          size="small"
                                                          onChange={(value) => {
                                                            handleChangeColumnVisibility(
                                                              column.key,
                                                              value
                                                            );
                                                          }}
                                                        />
                                                      </CustomizeItem>
                                                    )}
                                                  </Draggable>
                                                ))}
                                              {provided.placeholder}
                                            </CustomizeItems>
                                          )}
                                        </Droppable>
                                      </div>
                                    )}
                                  </div>
                                </DragDropContext>
                              )}

                              {customizeTab === "freeze" && (
                                <DragDropContext onDragEnd={onDragEndFreeze}>
                                  <>
                                    {customizeColumns?.filter(
                                      (column) => column.isFrozen
                                    )?.length > 0 && (
                                      <>
                                        <CustomizeTitle>
                                          Frozen Columns
                                        </CustomizeTitle>

                                        <Droppable droppableId="frozen-section">
                                          {(provided, snapshot) => (
                                            <CustomizeItems
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                              isDraggingOver={
                                                snapshot.isDraggingOver
                                              }
                                              isFrozen
                                            >
                                              {customizeColumns
                                                .filter(
                                                  (column) => column.isFrozen
                                                )
                                                .sort((a, b) => {
                                                  if (a.key === "action_items")
                                                    return -1;
                                                  if (b.key === "action_items")
                                                    return 1;
                                                  return 0;
                                                })
                                                .map((column, index) => {
                                                  const isActionItem =
                                                    column.key ===
                                                    "action_items";
                                                  return (
                                                    <Draggable
                                                      key={column.key}
                                                      draggableId={column.key}
                                                      index={index}
                                                    >
                                                      {(provided, snapshot) => (
                                                        <CustomizeItem
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...(isActionItem
                                                            ? {}
                                                            : provided.draggableProps)}
                                                        >
                                                          <div className="customizeItem-title">
                                                            <div
                                                              {...(isActionItem
                                                                ? {}
                                                                : provided.dragHandleProps)}
                                                              style={{
                                                                cursor:
                                                                  isActionItem
                                                                    ? "default"
                                                                    : "grab",
                                                                display:
                                                                  "inline-block",
                                                                opacity:
                                                                  isActionItem
                                                                    ? 0
                                                                    : 1,
                                                                overflow:
                                                                  isActionItem
                                                                    ? "hidden"
                                                                    : "visible",
                                                              }}
                                                            >
                                                              <Dragding />
                                                            </div>

                                                            <h4>
                                                              {column.title}
                                                              {(column.key ===
                                                                "status" ||
                                                                column.key ===
                                                                  "action_items") && (
                                                                <p
                                                                  style={{
                                                                    color:
                                                                      "#155DFC",
                                                                    fontSize: 9,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                  }}
                                                                >
                                                                  (Recommended)
                                                                </p>
                                                              )}
                                                            </h4>
                                                          </div>
                                                          <Switch
                                                            checked={
                                                              column.isFrozen
                                                            }
                                                            size="small"
                                                            onChange={(value) =>
                                                              handleColumnFrozenChange(
                                                                column.key,
                                                                value
                                                              )
                                                            }
                                                          />
                                                        </CustomizeItem>
                                                      )}
                                                    </Draggable>
                                                  );
                                                })}
                                              {provided.placeholder}
                                            </CustomizeItems>
                                          )}
                                        </Droppable>
                                      </>
                                    )}

                                    {customizeColumns.filter(
                                      (column) => !column.isFrozen
                                    )?.length > 0 && (
                                      <div>
                                        <CustomizeTitle
                                          style={{ marginTop: "16px" }}
                                        >
                                          Unfrozen Columns
                                        </CustomizeTitle>
                                        <Droppable droppableId="unfrozen-section">
                                          {(provided, snapshot) => (
                                            <CustomizeItems
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                              isDraggingOver={
                                                snapshot.isDraggingOver
                                              }
                                            >
                                              {customizeColumns
                                                .filter(
                                                  (column) =>
                                                    !column.isFrozen &&
                                                    column.key ===
                                                      "action_items"
                                                )
                                                .map((column) => (
                                                  <CustomizeItem
                                                    key={column.key}
                                                  >
                                                    <div className="customizeItem-title">
                                                      <div
                                                        style={{
                                                          opacity: 0,
                                                          overflow: "hidden",
                                                        }}
                                                      >
                                                        <Dragding />
                                                      </div>
                                                      <h4>
                                                        {column.title}

                                                        <p
                                                          style={{
                                                            color: "#155DFC",
                                                            fontSize: 9,
                                                            margin: 0,
                                                            padding: 0,
                                                          }}
                                                        >
                                                          (Recommended)
                                                        </p>
                                                      </h4>
                                                    </div>
                                                    <Switch
                                                      checked={column.isFrozen}
                                                      size="small"
                                                      onChange={(value) =>
                                                        handleColumnFrozenChange(
                                                          column.key,
                                                          value
                                                        )
                                                      }
                                                    />
                                                  </CustomizeItem>
                                                ))}

                                              {customizeColumns
                                                .filter(
                                                  (column) =>
                                                    !column.isFrozen &&
                                                    column.key !==
                                                      "action_items"
                                                )
                                                .map((column, index) => {
                                                  return (
                                                    <Draggable
                                                      key={column.key}
                                                      draggableId={column.key}
                                                      index={index}
                                                    >
                                                      {(provided, snapshot) => (
                                                        <CustomizeItem
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                        >
                                                          <div className="customizeItem-title">
                                                            <div
                                                              {...provided.dragHandleProps}
                                                              style={{
                                                                cursor: "grab",
                                                                display:
                                                                  "inline-block",
                                                              }}
                                                            >
                                                              <Dragding />
                                                            </div>
                                                            <h4>
                                                              {column.title}
                                                              {column.key ===
                                                                "status" && (
                                                                <p
                                                                  style={{
                                                                    color:
                                                                      "#155DFC",
                                                                    fontSize: 9,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                  }}
                                                                >
                                                                  (Recommended)
                                                                </p>
                                                              )}
                                                            </h4>
                                                          </div>
                                                          <Switch
                                                            checked={
                                                              column.isFrozen
                                                            }
                                                            size="small"
                                                            onChange={(value) =>
                                                              handleColumnFrozenChange(
                                                                column.key,
                                                                value
                                                              )
                                                            }
                                                          />
                                                        </CustomizeItem>
                                                      )}
                                                    </Draggable>
                                                  );
                                                })}
                                              {provided.placeholder}
                                            </CustomizeItems>
                                          )}
                                        </Droppable>
                                      </div>
                                    )}

                                    <FrozenTextBox>
                                      <p>
                                        Frozen columns will stay visible while
                                        scrolling horizontally.
                                      </p>
                                      <p>
                                        We recommend freezing essential columns
                                        like <b>"Action Items"</b> or{" "}
                                        <b>"Status"</b> for better readability.
                                      </p>
                                      <p
                                        style={{
                                          fontStyle: "italic",
                                          fontSize: 9,
                                          color: "#4A5565",
                                        }}
                                      >
                                        Category column is always frozen by
                                        default.
                                      </p>
                                    </FrozenTextBox>
                                  </>
                                </DragDropContext>
                              )}
                            </CustomizePopoverContent>
                          </CustomizePopover>
                        </>
                      }
                      open={isCustomizePopoverActive}
                      onOpenChange={(visible) =>
                        setIsCustomizePopoverActive(visible)
                      }
                      trigger="click"
                      overlayClassName="CustomizePopover"
                      zIndex={100000}
                      overlayStyle={{
                        zIndex: 100000,
                        pointerEvents: "auto",
                        position: "fixed",
                        top: `${popoverPosition.top}px`,
                        right: 12,
                        left: "auto",
                        transform: "none",
                      }}
                      autoAdjustOverflow={false}
                      placement="bottomRight"
                      builtinPlacements={{
                        bottomRight: {
                          points: ["tr", "br"],
                          offset: [0, 0],
                        },
                      }}
                      destroyTooltipOnHide={false}
                    >
                      {isCustomizePopoverActive ? (
                        <Setting
                          onClick={() =>
                            setIsCustomizePopoverActive(
                              !isCustomizePopoverActive
                            )
                          }
                        />
                      ) : (
                        <SettingGray
                          onClick={() =>
                            setIsCustomizePopoverActive(
                              !isCustomizePopoverActive
                            )
                          }
                        />
                      )}
                    </Popover>
                  </div>
                </HeadItem>

                <ExtraDiv />
              </UnFrozenWrapper>
            </Head>

            <Accordion
              as={Body}
              activeKey={activeKey
                .filter((item) => item.isExpand)
                .map((item) => item.id)}
            >
              {isAddCategory ? (
                <AddCategory
                  isShared={isShared}
                  setIsAddCategory={setIsAddCategory}
                  onCreate={handleCategoryCreate}
                  isNewCategoryLoading={isNewCategoryLoading}
                />
              ) : null}
              <DragDropContext
                onDragEnd={handleDragEnd}
                onDragUpdate={handleDragUpdate}
                onDragStart={handleDragStart}
              >
                {planDetails.categories.map((item) => (
                  <Droppable droppableId={item.id.toString()} key={item.id}>
                    {(provided) => (
                      <Category
                        data={item}
                        additionalData={{
                          plan_start_date: planDetails.start_line,
                          plan_end_date: planDetails.dead_line,
                        }}
                        isActive={activeKey
                          .filter((a) => a.isExpand)
                          .map((a) => a.id)
                          .includes(item.id.toString())}
                        checkedItems={checkedItems}
                        setCheckedItems={setCheckedItems}
                        onToggle={handleToggle}
                        onAdjustWeight={handleAdjustWeightToggle}
                        isShared={isShared}
                        key={item.id}
                        provided={provided}
                        isAddCategory={isAddCategory}
                        PlanDetails={planDetails}
                        setIsAddCategory={setIsAddCategory}
                        customizeColumns={customizeColumns}
                        filterBy={filterBy}
                      />
                    )}
                  </Droppable>
                ))}
              </DragDropContext>
            </Accordion>
          </Wrapper>
        </Container>
      ) : (
        <CardViewWrapper>
          {Object.entries(groupedByStatus).map(([key, value]) => (
            <ActionItemCardView
              data={value}
              status={key}
              SetData={SetData}
              setIsNoteModel={setIsNoteModel}
              setIsButtonDisabled={setIsButtonDisabled}
              isShared={isShared}
            />
          ))}
        </CardViewWrapper>
      )}

      <BulkAction
        style={{
          transition: "all 0.3s ease",
          opacity: isBulkShow ? "1" : "0",
          visibility: isBulkShow ? "visible" : "hidden",
          transform: isBulkShow
            ? "translateY(0) translateX(-50%)"
            : "translateY(100px) translateX(-50%)",
        }}
      >
        {isDisabled && (
          <BulkActionLoading>
            <LoadingOutlined />
          </BulkActionLoading>
        )}

        {isUndo && (
          <div
            className="bulk-action-item bulk-action-undo"
            onClick={handleUndo}
          >
            <UndoIcon />

            <h3>Undo</h3>
          </div>
        )}

        <div className="bulk-action-item">
          <div className="bulk-action-item-icon">
            <StarIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.weight
                  ? "active"
                  : ""
              }`}
            />
          </div>
          <Select
            className={`bulk-action-select ${
              isDisabledBulkAction ? "disabled-action-select" : ""
            }`}
            bordered={false}
            suffixIcon={null}
            disabled={isDisabledBulkAction}
            value={bulkAction.weight}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }

              if (!isFocus.weight) {
                setIsFocus({
                  weight: true,
                });
              } else {
                setIsFocus({
                  weight: false,
                });
              }
            }}
            onBlur={() => {
              setIsFocus({
                weight: false,
              });
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                weight: true,
              });
            }}
            onChange={(value) => {
              setBulkAction({ ...bulkAction, weight: value });
              setIsFocus({
                weight: false,
              });

              handleBulkAction("weight", value);
            }}
            style={{
              width: "80px",
            }}
            size="small"
            options={actionItemWeightOptions}
          />
        </div>

        <div className="bulk-action-item">
          <div className="bulk-action-item-icon">
            <PlanProgressIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.planProgress
                  ? "active"
                  : ""
              }`}
            />
          </div>
          <Select
            className={`bulk-action-select ${
              isDisabledBulkAction ? "disabled-action-select" : ""
            }`}
            bordered={false}
            suffixIcon={null}
            value={bulkAction.planProgress}
            disabled={isDisabledBulkAction}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }

              if (!isFocus.planProgress) {
                setIsFocus({
                  planProgress: true,
                });
              } else {
                setIsFocus({
                  planProgress: false,
                });
              }
            }}
            onChange={(value) => {
              setBulkAction({ ...bulkAction, planProgress: value });
              setIsFocus({
                planProgress: false,
              });

              handleBulkAction("planProgress", value);
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                planProgress: true,
              });
            }}
            onBlur={() => {
              setIsFocus({
                planProgress: false,
              });
            }}
            style={{
              width: "125px",
            }}
            size="small"
            options={actionItemWeightOptions}
          />
        </div>

        <div className="bulk-action-item">
          <div className="bulk-action-item-icon">
            <DurationIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.duration
                  ? "active"
                  : ""
              }`}
            />
          </div>
          <Select
            className={`bulk-action-select ${
              isDisabledBulkAction ? "disabled-action-select" : ""
            }`}
            popupClassName="bulk-action-select-duration"
            bordered={false}
            suffixIcon={null}
            value={bulkAction.duration}
            disabled={isDisabledBulkAction}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }

              if (!isFocus.duration) {
                setIsFocus({
                  duration: true,
                });
              } else {
                setIsFocus({
                  duration: false,
                });
              }
            }}
            onChange={(value) => {
              setBulkAction({ ...bulkAction, duration: value });
              setIsFocus({
                duration: false,
              });

              handleBulkAction("duration", value);
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                duration: true,
              });
            }}
            onBlur={() => {
              setIsFocus({
                duration: false,
              });
            }}
            style={{
              width: "90px",
            }}
            size="small"
            options={durationList?.map((item) => ({
              label: item.key,
              value: item.value,
            }))}
          />
        </div>

        <div className="bulk-action-item">
          <div className="bulk-action-item-icon">
            <AssigneeIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.assignee
                  ? "active"
                  : ""
              }`}
            />
          </div>
          <Select
            className={`bulk-action-select ${
              isDisabledBulkAction ? "disabled-action-select" : ""
            } ${userName === "Assignee" ? "" : "antd-assignee"}`}
            popupClassName="bulk-action-select-duration"
            bordered={false}
            suffixIcon={null}
            value={userName}
            labelInValue
            disabled={isDisabledBulkAction}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }

              if (!isFocus.assignee) {
                setIsFocus({
                  assignee: true,
                });
              } else {
                setIsFocus({
                  assignee: false,
                });
              }
            }}
            onBlur={() => {
              setIsFocus({
                assignee: false,
              });
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                assignee: true,
              });
            }}
            onChange={(value: any) => {
              setBulkAction({ ...bulkAction, assignee: value?.label });
              setIsFocus({
                assignee: false,
              });

              handleBulkAction("assignee", value);
            }}
            size="small"
          >
            {(AssignOptions ?? [])?.map((option: any, index: any) => {
              const selectedUser = option?.label == bulkAction?.assignee;

              return (
                <Select.Option
                  key={index}
                  value={option.value}
                  style={{
                    backgroundColor: selectedUser ? "#e6f7ff" : "#fff",
                  }}
                >
                  {option.label}
                </Select.Option>
              );
            })}
          </Select>
        </div>

        <div className="bulk-action-item">
          <div className="bulk-action-date-picker-icon">
            <CalendarIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.startDate
                  ? "active"
                  : ""
              }`}
            />
          </div>

          <DatePicker
            className={`bulk-action-date-picker ${
              isFocus.startDate ? "focused-action-select" : ""
            } ${isDisabledBulkAction ? "disabled-action-select" : ""}`}
            bordered={false}
            suffixIcon={null}
            allowClear={false}
            style={{
              width: "130px",
            }}
            open={isFocus.startDate}
            disabledDate={(current) => {
              return isDateDisabled(current, "start_line");
            }}
            placeholder="Start Date"
            disabled={isDisabledBulkAction}
            value={bulkAction.startDate}
            inputReadOnly
            onChange={(value) => {
              if (isDisabledBulkAction) {
                return;
              }

              setBulkAction({ ...bulkAction, startDate: value });
              handleBulkAction("startDate", value);
              setIsFocus({});
            }}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }
              setIsFocus({
                startDate: true,
              });
            }}
            onBlur={() => {
              setIsFocus({});
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                startDate: true,
              });
            }}
          />
        </div>

        <div className="bulk-action-item">
          <div className="bulk-action-date-picker-icon">
            <BellIcon
              className={`${
                isDisabledBulkAction
                  ? "disabled"
                  : isFocus.dueDate
                  ? "active"
                  : ""
              }`}
            />
          </div>

          <DatePicker
            className={`bulk-action-date-picker ${
              isFocus.dueDate ? "focused-action-select" : ""
            } ${isDisabledBulkAction ? "disabled-action-select" : ""}`}
            bordered={false}
            suffixIcon={null}
            allowClear={false}
            style={{
              width: "130px",
            }}
            disabledDate={(current) => {
              return isDateDisabled(current, "dead_line");
            }}
            placeholder="Due Date"
            disabled={isDisabledBulkAction}
            value={bulkAction.dueDate}
            inputReadOnly
            onSelect={(value) => {
              if (isDisabledBulkAction) {
                return;
              }

              setBulkAction({ ...bulkAction, dueDate: value });

              handleBulkAction("dueDate", value);
            }}
            onClick={() => {
              if (isDisabledBulkAction) {
                return;
              }
              setIsFocus({
                dueDate: true,
              });
            }}
            onBlur={() => {
              setIsFocus({
                dueDate: false,
              });
            }}
            onFocus={(e) => {
              e.preventDefault();
              setIsFocus({
                dueDate: true,
              });
            }}
          />
        </div>

        <div
          className="bulk-action-item"
          style={{
            opacity: isDisabledBulkAction ? 0.5 : 1,
            cursor: isDisabledBulkAction ? "not-allowed" : "pointer",
          }}
          onClick={handleDeleteItems}
        >
          <DeleteIcon />
          <h3>Delete</h3>
        </div>
      </BulkAction>
    </>
  );
};

export default ActionItems;
